import { useEffect, useState } from 'react';

import useGetLevelAccessByIdQuery from '@/modules/role/queries/useGetLevelAccessById.query';

import { useFieldLevelAccessSetupStore } from '../stores';

const TIMEOUT = 500;
const useFieldLevelAccessLoad = (id: string) => {
  const { isLoading: isLevelLoading, isSuccess, data } = useGetLevelAccessByIdQuery({ id });
  const setState = useFieldLevelAccessSetupStore((state) => state.setState);
  const handleReset = useFieldLevelAccessSetupStore((state) => state.handleReset);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if(data) {      
      setState({
        ...data,
      });
    }
  }, [data, setState]);
  useEffect(() => {
    if(isLevelLoading === false) {
      setTimeout(() => {
        setIsLoading(false);
      }, TIMEOUT);
    }
  }, [isLevelLoading]);

  useEffect(() => {
    return () => {
      handleReset();
    };
  }, [handleReset]);
  return {
    isSuccess,
    isLoading
  };
};

export default useFieldLevelAccessLoad;